/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import FacebookLoginRender from "react-facebook-login/dist/facebook-login-render-props";
import styles from "./FacebookSignInButton.module.scss";
import SocialLogin from "mutation/SocialLogin";
import AuthenticationContext from "state/authentication";
import {getAnalytics, logEvent} from "firebase/analytics";

interface Props {
    className?: string;
}

const FacebookSignInButton: React.FC<Props> = ({className}) => {
    const authenticationContext = React.useContext(AuthenticationContext);

    const responseFacebook = React.useCallback(async (response) => {
        const analytics = getAnalytics();
        logEvent(analytics, 'facebook_sign_in_response')
        const token = response.accessToken;
        const accessToken = await SocialLogin(token, "FACEBOOK");
        authenticationContext.setAccessToken(accessToken);
    }, [authenticationContext]);

    return (
        <div className={className}>
            <FacebookLoginRender
                fields={"email"}
                appId={"3173909916264583"}
                callback={responseFacebook}
                render={(renderProps) => (
                    <button className={styles.buttonContainer} onClick={(e) => {
                        const analytics = getAnalytics();
                        logEvent(analytics, 'facebook_sign_in_started')
                        renderProps.onClick()
                    }
                    }>
                        <img alt={"facebook logo"} className={styles.buttonImg} src={"f_logo_RGB-White_72.png"}/>
                        <span className={styles.buttonText}>Continue with Facebook</span>
                    </button>
                )}
            />
        </div>
    );
}

export default FacebookSignInButton;